import { useMemo } from 'react';
import { Place } from 'features/places/places.types';
import { usePlaces } from 'features/places/hooks/usePlaces';

type UsePlaceReturn = {
  place: Place | undefined;
  loading: boolean;
};

export const usePlace = (placeId: number): UsePlaceReturn => {
  const { places, loading } = usePlaces();

  const place = useMemo(
    () => places.find((p) => p.id === placeId),
    [places, placeId],
  );

  return { place, loading };
};
